import { useEffect, useState } from 'react'
import type { User } from '../types'
import { authService } from '../modules/identity/services/auth'

/**
 * Returns the current user, refreshing from /auth/me on mount so that
 * feature flags updated by an admin are picked up without re-login.
 */
export function useCurrentUser(): User | null {
  const [user, setUser] = useState<User | null>(authService.getCurrentUser())

  useEffect(() => {
    authService.fetchMe()
      .then(setUser)
      .catch(() => { /* network failure — keep stale value */ })
  }, [])

  return user
}
